<template>
  <div id="staff-service" class="vs-con-loading__container">
    <div>
      <div
        v-for="(category, index) in arr_serviceData"
        :key="index"
        @click="updateCurrentCategory(category)"
      >
        <div v-if="category.services && category.services.length != 0">
          <div class="p-4 px-2 category-content">
            <div v-if="category.id != 999999">
              <vs-checkbox class="w-auto" v-model="activeCategory[index]" @click="updateCategoryStatus(category, index)">
                <h4 class="text-lg font-bold pl-3">{{category.name}}</h4>
              </vs-checkbox>
            </div>
            <div v-else class="other-category">
              <h4 class="text-lg font-bold pl-3">{{category.name}}</h4>
            </div>
          </div>
          <div class="service-list rounded-item">
            <vs-button
              type="border"
              v-for="service in category.services"
              class="user-select-none"
              :key="service.id"
              :class="{'active': isActiveService(service.id)}"
              @click="updateStaffService(service.id, index)"
            >{{service.name}}</vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "staff-service",
  props: {
    serviceData: {
      type: Array,
      required: true
    },
    staffServiceData: {
      type: Array,
      required: true
    },
    activeStaffData: {
      type: Object,
      required: true
    }
  },
  data() {
    // console.log(this.staffServiceData);
    // console.log(this.serviceData);
    // let arr_serviceData = Object.values(this.serviceData);
    let serviceListOnly = [];
    for(let i = 0; i < this.serviceData.length; i++) {
      let cate = this.serviceData[i];
      let service_temp = [];
      if((cate.type == 'service' || cate.type == undefined) && cate.status == 2) {
          for(let j = 0; j < cate.services.length; j++) {
              if(cate.services[j].status == 1) {
                  service_temp.push(cate.services[j]);
              }
          }
          serviceListOnly.push({id: cate.id, name: cate.name, services: service_temp, color_detail: cate.color_detail});
      }
    }
    // let arr_serviceData = this.serviceData;
    let arr_serviceData = serviceListOnly;
    let activeCategory = [];
    for(let i = 0; i < arr_serviceData.length; i++) {
      if(this.checkActiveCategory(arr_serviceData[i].services)) {
        activeCategory.push(true);
      } else {
        activeCategory.push(false);
      }
    }
    let checkAll = false;
    // for(let i = 0; i < this.activeCategory.length; i++) {
    //     if(this.activeCategory[i] == false) {
    //       checkAll = false;
    //     }
    // }
    // console.log(checkAll);
    return {
      currentCategory: {},
      currentService: {},
      arr_serviceData,
      activeCategory,
      checkAll,
      isOpenLoading: false
      // backgroundLoading:'primary',
      // colorLoading:'#fff',
    };
  },
  methods: {
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#staff-list',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: 'Update service for staff failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: 'Update service for staff failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);

    },
    closeLoading() {
      this.isOpenLoading = false;
      setTimeout( ()=> {
        this.$vs.loading.close('#staff-list > .con-vs-loading');
      }, 200);
    },
    updateCurrentCategory(category) {
      this.currentCategory = category;
    },
    isActiveService(id) {
        for(let i = 0; i < this.staffServiceData.length; i++) {
            if(this.staffServiceData[i].service_id == id) {
                return true;
            }
        }
        return false;
    },
    checkActiveCategory(services) {
      if(services.length == 0) return false;
      for(let i = 0; i < services.length; i++) {
        if(this.isActiveService(services[i].id) == false) {
          return false;
        }
      }
      return true;
    },
    updateStaffService(id, index) {
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      if(this.isActiveService(id)) {
        this.deleteService(id, index);
      } else {
        this.addService(id, index);
      }
    },
    updateCategoryStatus(category, index) {
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      if(this.activeCategory[index]) {
        this.deleteAllService(category.services, index);
      } else {
        this.addAllService(category.services, index);
      }
    },
    arrToString(arr) {
      let temp_string = '';
      for(let i= 0; i< arr.length; i++) {
        if(i == 0) {
          temp_string += arr[0].id;
        } else {
          temp_string += ',' + arr[i].id;
        }
      }
      return temp_string;
    },
    deleteAllService(services, index) {
      this.activeCategory[index] = false;
      // for(let i = 0; i < services.length; i++) {
      //   this.deleteService(services[i].id, index);
      // }
      // this.checkAll = false;
      let delete_string = this.arrToString(services);
      // console.log("delete: " + delete_string);
      // this.$emit('DeleteStaffService', delete_string);
      const obj = {
        staff_id: this.activeStaffData.user_id,
        services: delete_string
      }
      this.$store.dispatch("staffList/REMOVE_SERVICE_FROM_STAFF", obj).then(() => {
        this.closeLoading();
      })
    },
    addAllService(services, index) {
      this.activeCategory[index] = true;
      // for(let i = 0; i < services.length; i++) {
      //   this.addService(services[i].id, index);
      // }
      let add_string = this.arrToString(services);
      // console.log("add: " + add_string);
      // this.$emit('AddStaffService', add_string);
      const obj = {
        staff_id: this.activeStaffData.user_id,
        services: add_string
      }
      this.$store.dispatch("staffList/ADD_SERVICE_TO_STAFF", obj).then(() => {
        this.closeLoading();
      })
    },
    deleteService(id, index) {
      if(this.isActiveService(id)) {
        // this.$emit('DeleteStaffService', id);
        // this.checkAll = false;
        this.activeCategory[index] = false;
        const obj = {
          staff_id: this.activeStaffData.user_id,
          services: id
        }
        this.$store.dispatch("staffList/REMOVE_SERVICE_FROM_STAFF", obj).then(() => {
          this.closeLoading();
        })
      }
      // console.log(this.staffServiceData);
    },
    addService(id, index) {
      if(this.isActiveService(id) == false) {
        // this.$emit('AddStaffService', id);
        // if(this.isCheckAllService(index)) {
        //   this.activeCategory[index] = true;
        // }
        // else {
        //   console.log(this.isCheckAllService(index))
        // }
        const obj = {
          staff_id: this.activeStaffData.user_id,
          services: id
        }
        this.$store.dispatch("staffList/ADD_SERVICE_TO_STAFF", obj).then(() => {
          this.closeLoading();
        })
        this.isCheckAllService(id, index);
      }
      // console.log(this.staffServiceData);
    },
    isCheckAllService(id, index) {
      // let services_in_category = this.arr_serviceData[index].services;
      // console.log(services_in_category)
      // console.log(this.arr_serviceData[index].services)
      for(let i = 0; i < this.arr_serviceData[index].services.length; i++) {
        // console.log('a');
        // console.log(services_in_category[i]);
        if(this.isActiveService(this.arr_serviceData[index].services[i].id) == false && this.arr_serviceData[index].services[i].id != id) {
          // console.log(this.arr_serviceData[index].services[i].id);
          // console.log(this.isActiveService(this.arr_serviceData[index].services[i].id) == false);
          return false;
        }
      }
      this.activeCategory[index] = true;
      return true;
    },
    // isCheckAll() {
    //   for(let i = 0; i < this.activeCategory.length; i++) {
    //     if(this.activeCategory[i] == false) {
    //       return false;
    //     }
    //   }
    //   return true;
    // },
    updateCheckAll() {
      if(this.checkAll) {
        for(let i = 0; i < this.arr_serviceData.length; i++) {
          this.deleteAllService(this.arr_serviceData[i].services, i);
        }
      } else {
        for(let i = 0; i < this.arr_serviceData.length; i++) {
          this.addAllService(this.arr_serviceData[i].services, i);
        }
      }
    }
  }
  // created() {
  //     this.updateCurrentCategory(this.arr_serviceData[0]);
  // }
};
</script>
